(() => {
  'use strict';
  function pageContext(path = location.pathname) {
    const collection = path.match(/^\/(?:collections|a\/search)\/([^/]+)\/?$/);
    if (collection) return { path: `/collections/${collection[1]}`, type: 'collection' };
    if (/^\/a\/search\/?$/.test(path)) return { path: '/a/search', type: 'search' };
    return null;
  }
  if (window.__premierFilterTracking || !pageContext()) return;
  window.__premierFilterTracking = true;
  const storageKey = 'premier_filter_change';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  const controlSelector = '.cloud-search-filter, .cloud-search-applied-filter, [class*="cloud-search"][class*="clear"]';
  let pending = null;
  let timer = null;
  let dragging = false;
  let expiryTimer = null;
  const filterRoots = '#cloud_search_filters_sidebar, #cloud_search_filters_root, .cloud-search-filter, .cloud-search-filters-sidebar__applied-filters, .cloud-search-page-controls__applied-filters';
  const observedRoots = new Set();
  const observer = new MutationObserver(() => { if (pending && !dragging) schedule(); });
  function observeFilters() {
    const roots = new Set(document.querySelectorAll(filterRoots));
    if (roots.size === observedRoots.size && Array.from(roots).every(root => observedRoots.has(root))) return;
    observer.disconnect();
    observedRoots.clear();
    for (const root of roots) {
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-filter-values'] });
      observedRoots.add(root);
    }
  }
  function snapshot() {
    const values = {};
    for (const chip of document.querySelectorAll('.cloud-search-applied-filter[data-filter-name]')) {
      const name = clean(chip.getAttribute('data-filter-name'));
      if (/^price\b/i.test(name)) continue;
      const value = clean(chip.querySelector('[data-filter-values]')?.getAttribute('data-filter-values'));
      if (name && value) values[name] = value;
    }
    return values;
  }
  function discard() {
    pending = null;
    dragging = false;
    observer.disconnect();
    observedRoots.clear();
    if (timer !== null) clearTimeout(timer);
    timer = null;
    if (expiryTimer !== null) clearTimeout(expiryTimer);
    expiryTimer = null;
    try { window.sessionStorage.removeItem(storageKey); } catch (_) {}
  }
  function schedule() {
    if (timer !== null) clearTimeout(timer);
    if (pending && !dragging) timer = setTimeout(flush, 800);
  }
  function flush() {
    timer = null;
    if (!pending) return;
    const page = pageContext();
    if (!allowed() || Date.now() - pending.created > 15000 || pending.path !== page?.path) { discard(); return; }
    if (dragging) return;
    observeFilters();
    const after = snapshot();
    const before = pending.before;
    const names = Array.from(new Set([...Object.keys(before), ...Object.keys(after)]));
    const changes = names.filter(name => before[name] !== after[name]);
    if (!changes.length || typeof window.gtag !== 'function') { schedule(); return; }
    discard();
    for (const name of changes) {
      if (!allowed()) break;
      try {
        window.gtag('event', 'product_filter_change', {
          send_to: 'G-3JGML5ZLZK',
          source_path: page.path,
          page_type: page.type,
          filter_name: name,
          filter_value: after[name] || before[name],
          previous_filter_value: before[name] || '',
          filter_action: !after[name] ? 'removed' : !before[name] ? 'applied' : 'updated',
          active_filter_groups: Object.keys(after).length,
          ...(window.__premierFilterDebugMode === true ? { debug_mode: true } : {}),
          ...(window.__premierFilterTestMode === true ? { traffic_type: 'navigation_test' } : {})
        });
      } catch (_) {}
    }
  }
  function arm(event) {
    if (event.type === 'pointerup') { dragging = false; if (pending) schedule(); }
    if (!(event.target instanceof Element) || !event.target.closest(controlSelector) || !allowed()) return;
    const filter = event.target.closest('[data-filter-name]');
    if (filter && /^price\b/i.test(clean(filter.getAttribute('data-filter-name')))) return;
    if (event.target.closest('.cloud-search-filter__name')) return;
    if (event.type === 'keyup' && event.key !== 'Enter' && event.key !== ' ') return;
    if (!pending) {
      const page = pageContext();
      if (!page) return;
      pending = { before: snapshot(), path: page.path, created: Date.now() };
      expiryTimer = setTimeout(discard, 15000);
      observeFilters();
    }
    if (event.type === 'pointerdown' && event.target.closest('.cloud-search-range-slider')) dragging = true;
    if (event.type === 'pointerdown' || event.type === 'click' || event.type === 'keyup' || event.type === 'change') {
      try { window.sessionStorage.setItem(storageKey, JSON.stringify(pending)); } catch (_) {}
    }
    schedule();
  }
  for (const type of ['pointerdown', 'click', 'change', 'pointerup', 'keyup']) document.addEventListener(type, arm, true);
  document.addEventListener('pointercancel', () => { dragging = false; if (pending) schedule(); }, true);
  document.addEventListener('visitorConsentCollected', () => { if (!allowed()) discard(); });
  function initialise() {
    let saved;
    try { saved = JSON.parse(window.sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
    if (saved) {
      let previous;
      try { previous = new URL(document.referrer); } catch (_) {}
      if (allowed() && saved.path === pageContext()?.path && Number.isFinite(saved.created) &&
          Date.now() >= saved.created && Date.now() - saved.created < 15000 &&
          saved.before && typeof saved.before === 'object' && previous?.origin === location.origin && pageContext(previous.pathname)?.path === saved.path) {
        pending = saved;
        expiryTimer = setTimeout(discard, Math.max(0, 15000 - (Date.now() - saved.created)));
        observeFilters();
        schedule();
      } else discard();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
